import { render, staticRenderFns } from "./SBImageTitle.html?vue&type=template&id=26e37a5e&scoped=true&"
import script from "./SBImageTitle.ts?vue&type=script&lang=ts&"
export * from "./SBImageTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SBImageTitle.css?vue&type=style&index=0&id=26e37a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e37a5e",
  null
  
)

export default component.exports